import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../img/Logo.png';
import { HeaderStyle } from './styles';


function Header() {
  function deslogar(){
    localStorage.removeItem("KenzieHub-auth");
  }
  return(
  <HeaderStyle>
    <img src={Logo} alt="logo kenzieHub" />
    <Link className='linkVoltar' onClick={deslogar} to="/">Sair</Link>
  </HeaderStyle>
  ) 
}

export default Header;